import React from "react";
import ButtonComponent from "../../../atoms/button";
import PropTypes from "prop-types";
import { ADD_ON, S } from "../../../../constants/common/common";
import { useSelector } from "react-redux";
import dynamic from "next/dynamic";

const PriceBreakUp = dynamic(() => import("./priceBreakUp"), {
  ssr: false,
});

/**
 * Component that renders the footer for the desktop layout, displaying
 * pricing information and handling the continuation of the process.
 *
 * @param {Object} props - The component props.
 * @param {function} props.calculateAddonCount - Function to calculate the count of add-ons.
 * @param {number} props.basePrice - The base price of the product.
 * @param {function} props.calculateAddonTotal - Function to calculate the total cost of add-ons.
 * @param {function} props.calculateTotal - Function to calculate the overall total price.
 * @param {function} props.onContinueClick - Function to handle the continuation action.
 */
const DesktopFooter = ({ calculateAddonCount, onContinueClick }) => {
  const comboPriceBreakupDetails = useSelector(
    (state) => state?.pdp?.clientCurrentClickedItem?.comboPriceBreakupDetails,
  );

  return (
    <div
      className={`flex items-center justify-end gap-28 border-t-1 border-lightGrey bg-white-900 px-20  py-8 ${comboPriceBreakupDetails ? "justify-between" : "justify-end"}`}
    >
      <PriceBreakUp isMobile={false} />

      <div
        className={`flex h-[40px] w-[311px] items-center  justify-center rounded-lg ${
          calculateAddonCount() > 0 ? "bg-[#737530]" : "border border-oliveGreen text-fnp-300"
        } transition-all duration-300 ease-in-out hover:bg-opacity-80`}
      >
        <ButtonComponent
          onClick={onContinueClick}
          size="textBtn"
          buttonVariant="filled"
          label={
            calculateAddonCount() > 0 ? (
              <div className="flex items-center justify-center gap-8">
                Continue
                <span className="h-[8px] w-[8px] rounded-full bg-white-900" />
                <span className="text-14 font-400">
                  {calculateAddonCount()} {ADD_ON}
                  {calculateAddonCount() > 1 ? S : ""}
                </span>
              </div>
            ) : (
              "Skip & Continue"
            )
          }
          classes="bg-opacity-0 transition-all duration-300 ease-in-out h-full"
          labelStyle={`${calculateAddonCount() > 0 ? "text-16" : "text-16 text-fnp-300"}`}
          btnParentClasses="h-full flex w-full items-center justify-center"
        />
      </div>
    </div>
  );
};

DesktopFooter.propTypes = {
  calculateAddonCount: PropTypes.func.isRequired,
  onContinueClick: PropTypes.func.isRequired,
};

export default DesktopFooter;
